import React, { FC } from 'react';
import clsx from 'clsx';
import {
    SrWidgetLiveMatchTracker,
    SrWidgetLiveMatchTrackerProps
} from '../match-statistics/sportradar-widgets/SrWidgetLiveMatchTracker';
import { WidgetWrapper } from '../match-statistics/sportradar-widgets/WidgetWrapper';

const BetradarMTAnimation: FC<SrWidgetLiveMatchTrackerProps> = ({ ...props }) => {
    return (
        <WidgetWrapper>
            <SrWidgetLiveMatchTracker
                className={clsx('betradar-animation-widget', {
                    'betradar-animation-embeded mb-15 pb-8 ': props.momentumDisabled
                })}
                {...props}
            />
        </WidgetWrapper>
    );
};

export default BetradarMTAnimation;
